<div class="card-white">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">ABC Artículos</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <span class="p-input-icon-left search-input">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt?.filterGlobal($any($event.target).value, 'contains')" placeholder="Buscar..." class="p-inputtext-sm" appPermissionControl="P099K0001" />
        </span>
        <button mat-flat-button (click)="openCreate()" class="btn-new" appPermissionControl="P099B0001">
          <mat-icon>add</mat-icon>
          Nuevo
        </button>
      </div>
    </div>
  </div>

  <p-table
    #dt
    [value]="dataSource"
    [columns]="columns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    scrollHeight="400px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [globalFilterFields]="['numero_articulo', 'numero_linea', 'descripcion']"
    [loading]="loading"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P099T0001"
  >
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P099C0001">
          {{ col.header }}
          <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <button pButton type="button" icon="pi pi-eye" (click)="openUpdate(rowData)" class="p-button-rounded p-button-text p-button-primary mr-2" appPermissionControl="P099B0002"></button>
              <button pButton type="button" icon="pi pi-trash" (click)="delete(rowData)" class="p-button-rounded p-button-text p-button-danger" appPermissionControl="P099B0003"></button>
            </ng-container>
            <ng-container *ngSwitchCase="'precio'">
              {{ formatCurrency(rowData[col.field]) }}
            </ng-container>
            <ng-container *ngSwitchCase="'precio_Propio'">
              {{ formatCurrency(rowData[col.field]) }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length" class="text-center td-prime">
          <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
          <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<app-abc-articulo-form [(visible)]="displayDialog" [model]="selectedData" (visibleChange)="onDialogClosed($event)"> </app-abc-articulo-form>
